import React from 'react';
import './AdminPages.css';

const defaultConfig = {
  siteName: 'DesignOps',
  contactEmail: 'hello@designops.com',
  supportEmail: 'support@designops.com',
  maintenanceMode: false,
  allowRegistrations: true,
  maxUploadSize: '10 MB',
  currency: 'INR (₹)',
  timezone: 'Asia/Kolkata'
};

const Settings = () => {
  return (
    <div className="admin-page">
      <h2 className="admin-page-title">Settings</h2>
      <p className="admin-page-desc">Site and panel configuration.</p>
      <div className="admin-page-card admin-settings-card">
        <div className="admin-settings-grid">
          <div className="admin-settings-row">
            <span className="admin-settings-label">Site Name</span>
            <span className="admin-settings-value">{defaultConfig.siteName}</span>
          </div>
          <div className="admin-settings-row">
            <span className="admin-settings-label">Contact Email</span>
            <span className="admin-settings-value">{defaultConfig.contactEmail}</span>
          </div>
          <div className="admin-settings-row">
            <span className="admin-settings-label">Support Email</span>
            <span className="admin-settings-value">{defaultConfig.supportEmail}</span>
          </div>
          <div className="admin-settings-row">
            <span className="admin-settings-label">Maintenance Mode</span>
            <span className="admin-settings-value">{defaultConfig.maintenanceMode ? 'On' : 'Off'}</span>
          </div>
          <div className="admin-settings-row">
            <span className="admin-settings-label">Allow Registrations</span>
            <span className="admin-settings-value">{defaultConfig.allowRegistrations ? 'Yes' : 'No'}</span>
          </div>
          <div className="admin-settings-row">
            <span className="admin-settings-label">Max Upload Size</span>
            <span className="admin-settings-value">{defaultConfig.maxUploadSize}</span>
          </div>
          <div className="admin-settings-row">
            <span className="admin-settings-label">Currency</span>
            <span className="admin-settings-value">{defaultConfig.currency}</span>
          </div>
          <div className="admin-settings-row">
            <span className="admin-settings-label">Timezone</span>
            <span className="admin-settings-value">{defaultConfig.timezone}</span>
          </div>
        </div>
        <p className="admin-settings-note">Edit these values in your environment or config file. Full CRUD coming soon.</p>
      </div>
    </div>
  );
};

export default Settings;
